import * as api from '@/api';

export function setWindowHeight() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function setUserCoordinatesIfNoSingleLocation({getters, commit}, payload) {
    if(!getters.singleLocationSelected) {
        commit('setUserCoordinates', payload);
    }
}

export async function checkAppConfig({commit}) {
    try {
        const appConfig = await api.static.appConfig()
        commit('setAppConfig', appConfig.data)
    } catch (error) {
        console.error(error)
    }
}